/*
 * (c) Copyright 2024 Calabrio, Inc.
 * All Rights Reserved. www.calabrio.com LICENSED MATERIALS
 * Property of Calabrio, Inc., Minnesota, USA
 *
 * No part of this publication may be reproduced, stored or transmitted,
 * in any form or by any means (electronic, mechanical, photocopying,
 * recording or otherwise) without prior written permission from Calabrio, Inc.
 */

import FlowsService from '../../service/flows';
import WyUtils from '../../library/wy-utils.js';
import WyFilter from '../../library/wy-filter.js';

const state = {
  
}

const getters = {
  
}

const mutations = {
  
}

const actions = {
  async fetchFlowsFilters({getters, dispatch, rootState}, {pageName}) {
    return new Promise(async (resolve) => {
      const dataModel = rootState.site.pages[pageName].dataModel;

      if(!dataModel.dateMax) {
        dataModel.filters = {
          'languages': {label: 'Language', name: 'languages', value: [], type: "checkbox", isRequire: true, category: 'moreFilters'},
          'custTypes': {label: 'Channel', name: 'custTypes', value: [], type: "checkbox", isRequire: true},
        }

        //call api to get real data
        let res = await FlowsService.fetchFlowsilters(getters.authUser);
        if(res && res.status==200 && res.data) {
          // date limits
          if(res.data.dateLimits && res.data.dateLimits.length > 0) {
            dataModel.dateMin = res.data.dateLimits[0].firstDate;
            dataModel.dateMax = res.data.dateLimits[0].lastDate;
          }
          
          // language list
          if(dataModel.filters.languages) {
            let languageMap = WyUtils.languageMap;
            dataModel.filters.languages.dataSource = (res.data.languages || []).map(item => {
              return {key: item.language, label: languageMap[item.language.toLowerCase()]}
            });
            dataModel.filters.languages.value = dataModel.filters.languages.dataSource.map(item => item.key);
          }
          
          // custTypes list
          if(dataModel.filters.custTypes) {
            dataModel.filters.custTypes.dataSource = (res.data.custTypes || []).map(item => {
              return {key: item.custType, label: WyUtils.toCamelCase(item.custType)}
            });
            dataModel.filters.custTypes.value = dataModel.filters.custTypes.dataSource.map(item => item.key);
          }
          
          await dispatch('initFilterOriginalSource');
          resolve();
        }
        else {
          resolve();
        }
      }
      else {
        resolve();
      }
    });
  },

  fetchFlowsData({getters, dispatch}, searchPath) {
    let payload = WyFilter.filterValues(getters.shareState, getters.dataModel, WyFilter.MODE_DATE_A);
    payload.ancestors = searchPath;

    dispatch('amplitudeLogFetchData', {eventName: 'conversation_flows_page_loaded', payload: payload});
    return FlowsService.fetchFlowsData(getters.authUser, payload);
  },

  fetchFlowsIntent({getters}) {
    let payload = WyFilter.filterValues(getters.shareState, getters.dataModel, WyFilter.MODE_DATE_A);
    return FlowsService.fetchFlowsIntent(getters.authUser, payload);
  },

  fetchFlowsTopicConversations({getters}, data) {
    let payload = WyFilter.filterValues(getters.shareState, getters.dataModel, WyFilter.MODE_DATE_A);
    payload.topics = data.topics;
    payload.messageId = data.messageId;
    if(data.from == "relatedTopics") payload.topicDisplayName = data.topicDisplayName;
    if(data.textQuery && data.textQuery != '') payload.textQuery = data.textQuery;
    if(data.sortBy) payload.sortBy = data.sortBy;
    if(data.pageNo) payload.pageNo = data.pageNo;
    if(data.pageSize) payload.pageSize = data.pageSize;

    if(data.date) {
      payload.dateStart = data.date;
      payload.dateEnd = data.date;
    }
    payload.from = data.from;    

    return FlowsService.fetchFlowsTopicConversations(getters.authUser, payload);
  },

  fetchFlowsMessages({getters}, {searchPath, pageNo, pageSize}) {
    let payload = WyFilter.filterValues(getters.shareState, getters.dataModel, WyFilter.MODE_DATE_A);
    payload.ancestors = searchPath;
    payload.pageNo = pageNo;
    payload.pageSize = pageSize;

    return FlowsService.fetchFlowsMessages(getters.authUser, payload);
  },
}

export default {
  state,
  getters,
  mutations,
  actions
}